import React, { useContext, useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import DashboardIcon from '@mui/icons-material/Dashboard';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import ArticleIcon from '@mui/icons-material/Article';
import AllOutIcon from '@mui/icons-material/AllOut';
import LogoutIcon from '@mui/icons-material/Logout';
import { useSelector, useDispatch } from 'react-redux';
import WorkerProfile from '../Dashboard/newProfile';
//import language context
import { LanguageContext } from '../global/languageContext';
import { ToastContainer, toast } from 'react-toastify';

const SideBar = (props) => {
	const profile_stat = useSelector(prev => prev.login);
	const userInfo = useSelector(e => e.userInfo);
  const EmployerProfile = useSelector((prev) => prev.employer);
	const EmployeeProfile = useSelector(e => e.profile);
  const body = EmployerProfile.message;
	const Type = profile_stat.profile_status.AcctType;
	const [ profile, setProfile ] = useState(true);
	useEffect(() => {

			if (profile_stat.profile_status.profile_status === "false" || profile_stat.profile_status.profile_status === false) {
				setProfile(false);
			}
	}, [profile_stat.profile_status]);

	const handleNoProfile = () => {
		setTimeout(() => {
			toast.error("You don't have a profile yet. Kindly generate a resume to create your profile", {
				position: toast.POSITION.TOP_RIGHT,
			});
		}, 50);
	}

	const handleNoResume = () => {
		setTimeout(() => {
			toast.error("You don't have a resume yet. Kindly generate a resume ", {
				position: toast.POSITION.TOP_RIGHT,
			});
		}, 50);
	}

	const { language, handleLanguageChange } = useContext(LanguageContext);
	const activeClassName = ({ isActive }) => {
		return isActive
			? 'text-base rounded-[56px] max-[1024px]:px-0 max-[1024px]:w-[70px] w-[274px] py-4 pl-10 btn-gradient flex max-[1024px]:justify-center items-center gap-2 text-white mx-auto'
			: 'text-[#898989] text-base rounded-[56px] w-[274px] max-[1024px]:px-0 max-[1024px]:w-[70px] py-4 pl-10 flex max-[1024px]:justify-center items-center gap-2 mx-auto';
	};
	const menuClassName = ({ isActive }) => {
		return isActive
			? 'text-base rounded-[56px]  w-full py-4 btn-gradient flex pl-4 items-center gap-2 text-white '
			: 'text-[#898989] text-base w-full py-4 flex items-center gap-2';
	}
	return (
		<aside className={`${props.isForMenu ? "w-[280px] py-4 px-4" : "SideBar hidden md:block max-[1024px]:w-[100px] w-[315px] pt-16 min-h-screen col-start-1 col-end-2 row-start-2 row-end-3 relative before:content-[''] before:fixed before:w-[1.5px] before:min-h-[150vh] before:bg-sec-300 before:top-[-50%] before:left-[99px] cont:before:left-[314px]"} z-[100]`}>
			<nav>
				<ul className="space-y-4">
					<li>
						{Type === "Client" ? 
						<>
						{profile === true ? <NavLink
							to={'/user/dashboard'}
							className={props.isForMenu ? menuClassName : activeClassName}>
							<DashboardIcon />
							<span className={`${props.isForMenu ? "" : "max-[1024px]:sr-only"}`}>{language["Dashboard"]}</span>
						</NavLink> : <NavLink
							to={'/user/dashboard1'}
							className={props.isForMenu ? menuClassName : activeClassName}>
							<DashboardIcon />
							<span className={`${props.isForMenu ? "" : "max-[1024px]:sr-only"}`}>{language["Dashboard"]}</span>
						</NavLink>}
						</> : 
						null
						}
					</li>
					<li>
						{Type === "Official" ? 
						<>
						{EmployerProfile.message !== null ? 
						<NavLink
						to={'/user/employer/profile'}
						className={props.isForMenu ? menuClassName : activeClassName}>
						<AccountBoxIcon />
						<span className={`${props.isForMenu ? "" : "max-[1024px]:sr-only"}`}> {language["Profile"]}</span>
						</NavLink> : <NavLink
							to={'/user/employer/form'}
							className={props.isForMenu ? menuClassName : activeClassName}>
							<AccountBoxIcon />
							<span className={`${props.isForMenu ? "" : "max-[1024px]:sr-only"}`}> {language["Profile"]}</span>
						</NavLink>}
						</> : <>{EmployeeProfile.message === null ? <NavLink
							to="#"
							onClick={() => handleNoProfile()}
							className={props.isForMenu ? menuClassName : activeClassName(false)}>
							<AccountBoxIcon />
							<span className={`${props.isForMenu ? "" : "max-[1024px]:sr-only"}`}> {language["Profile"]}</span>
						</NavLink> : 
							<NavLink
							to={`/user/profile/:${userInfo.user?.profile_id}`}
							className={props.isForMenu ? menuClassName : activeClassName}>
							<AccountBoxIcon />
							<span className={`${props.isForMenu ? "" : "max-[1024px]:sr-only"}`}> {language["Profile"]}</span>
						</NavLink>
							}</>
						}
					</li>
					<li>
						{Type === "Official" ? null : 
						<>
						{EmployeeProfile.message === null ? 
						<NavLink
						to="#"
						onClick={() => handleNoResume()}
						className={props.isForMenu ? menuClassName : activeClassName(false)}>
						<ArticleIcon />
						<span className={`${props.isForMenu ? "" : "max-[1024px]:sr-only"}`}>{language["My_resume"]}</span>
					</NavLink> : 
						<NavLink
						to={'/resume'}
						className={props.isForMenu ? menuClassName : activeClassName}>
						<ArticleIcon />
						<span className={`${props.isForMenu ? "" : "max-[1024px]:sr-only"}`}>{language["My_resume"]}</span>
					</NavLink>}
						</>
					}
					</li>
					<li>
						<NavLink
							to={'/user/logout'}
							className={props.isForMenu ? menuClassName : activeClassName}>
							<LogoutIcon />
							<span className={`${props.isForMenu ? "" : "max-[1024px]:sr-only"}`}>{language["Logout"]}</span>
						</NavLink>
					</li>
					{/*	<li>
						<NavLink
							to={'/'}
							className={ props.isForMenu ? 'text-base w-full py-4 rounded-[56px] flex items-center bg-pry-900 text-white pl-4 gap-2 mt-8' :
								'text-base rounded-[56px] w-[274px] max-[1024px]:w-[70px] max-[1024px]:px-0 py-4 pl-10 bg-pry-900 flex max-[1024px]:justify-center items-center gap-2 text-white mx-auto'
							}>
							<AllOutIcon />
							<span className={`${props.isForMenu ? "" : "max-[1024px]:sr-only"}`}>{language["Sub"]}</span>
						</NavLink>
					</li> */}
					{/* <li>
						<NavLink
							to={'/'}
							className={'text-slate-800 text-base font-normal underline leading-snug my-8 text-center block'}
						>
							<span className={`${props.isForMenu ? "" : "max-[1024px]:sr-only"}`}>{'Need help?'}</span>
						</NavLink>
					</li> */}
				</ul>
			</nav>
			<ToastContainer />
		</aside>
	);
};

export default SideBar;
